export default "__VITE_ASSET__DJqK9Mef__"